import lozad from 'lozad'
import 'intersection-observer';

const addFadeClass = element => element.classList.add('fade');

const LazyLoad = () => {
    const observer = lozad('.lozad', {
        rootMargin: '10px 0px',
        threshold: 0.5,

        loaded: function(element) {
            if (element.getAttribute('data-src')) {
                element.src = element.getAttribute('data-src');
                addFadeClass(element);
            }

            if (element.getAttribute('data-background-image')) {
                element.style.backgroundImage = 'url(' + element.getAttribute('data-background-image') + ')';
                element.getAttribute('data-animation') ? null : addFadeClass(element)
            }
        }
    });

    observer.observe();

};

export default LazyLoad;


// WEBPACK FOOTER //
// ./src/js/app/components/LazyLoad.js